import axios from 'axiosWrapper';
import {AxiosResponse, AxiosRequestConfig} from 'axios';

export function checkResponseStatus(response: AxiosResponse) {
    const {status, statusText, data} = response;

    if (status >= 400 || statusText.toLowerCase() !== 'ok' || !data) {
        throw new Error(`Request error with code ${status}`);
    }
}

export async function request<TData>({method, url, data, headers, params}: AxiosRequestConfig) {
    const response = await axios.request<TData>({
        method,
        data,
        url,
        params,
        headers,
    });
    checkResponseStatus(response);

    return response.data;
}
